function columnConverter(column) {
    if(column === 'home') {
        return '홈';
    } else if( column === 'away') {
        return '원정';
    } else if( column === 'MIN_DOO') {
        return '두산';
    } else if( column === 'MIN_LGT') {
        return 'LG';
    } else if( column === 'MIN_LOT') {
        return '롯데';
    } else if( column === 'MIN_SAM') {
        return '삼성';
    } else if( column === 'MIN_HER') {
        return '키움';
    } else if( column === 'MIN_HAN') {
        return '한화';
    } else if( column === 'MIN_KIA') {
        return 'KIA';
    } else if( column === 'MIN_KTW') {
        return 'KT';
    } else if( column === 'MIN_NCD') {
        return 'NC';
    } else if( column === 'MIN_HER') {
        return '고양';
    } else if( column === 'MIN_SSG') {
        return 'SSG';
    } else if( column === 'KBO_ARM') {
        return '상무';
    } else {
        return column;
    }
}

export default columnConverter;